var map = {
	"./de/numbers.json": [
		"1d9d",
		"chunk-2d0b65d4"
	],
	"./en/numbers.json": [
		"c185",
		"chunk-2d2160a1"
	],
	"./ru/numbers.json": [
		"4cb7",
		"chunk-2d0cc3fa"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6eb9";
module.exports = webpackAsyncContext;